<template>
    <div class="dashboard_wrp">
        <router-view></router-view>
    </div>

</template>
<script>
/*eslint-disable */
import Push from 'push.js';
import adapter from 'webrtc-adapter';
import {
  bus
} from '@/main';
import {
  mapGetters
} from 'vuex';
import moment from 'moment';
import commonSocket from '@/commonSocket/';

const $ = window.jQuery = require('jquery');
var schedulerPushNotification;
export default {
  name: 'lbil-dashboard',
  components: {
  },
  props: [],
  data () {
    return {
      userDetails:null,
      soketForSelfUserId:'',
      incomingCallNotification:false,
      callerName:'',
      hasWebrtcSupport: true,
      isClosed: true,
      currentUserId: null,
      userAcknowledgement:false,
      videoCallerUserId:'',
      isMobile:false,
      audioPlayer:null
    }
  },
  computed: {
    ...mapGetters([
      'selfUserInfoGetters'
    ]),
  getUserDetailsAgainFun(){
    this.userDetails = this.$store.getters.selfUserInfoGetters.data
    return
  },
  setIntialStates(){
    if(this.userDetails){
      this.soketForSelfUserId = this.userDetails.id
    }
    return
  }
  },
  mounted () {
    bus.$emit('headerPlatformBus', "LBIL");
    this.currentUserId = localStorage.getItem('LoginedUserID');
    if(localStorage.getItem('LoginedUserID'))
    if(sessionStorage.getItem('isClosed')) {
      this.isClosed = sessionStorage.getItem("isClosed");
    } else {
      this.isClosed = false;
    }
    if (!localStorage.getItem('token')) {
      this.$router.push('/');
    }
    this.$store.dispatch('getAuthHeader');
    this.getUserDetailsAgainFun
    this.setIntialStates
    bus.$emit('showHeaderbtn', true);
    $(".preloader").delay(200).fadeOut("slow");
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    schedulerIsReadStatusUpdateMethod(schedulerId){
      var data = {
        is_read:true
      }
      this.$store.dispatch('updateSchedulerDetailsAction', {data:{data:data,id:schedulerId}})
    },
    setPushNotificationForSchedulerMethod(){
      var __self = this
      var currentTime = new Date();
      var utcDate = new Date().toJSON().slice(0,10).replace(/-/g,'-');
      var utcTime = currentTime.getHours() + ":" + currentTime.getMinutes() + ":" + currentTime.getSeconds();
      var datetime = utcDate + ' ' + utcTime;
      this.$store.dispatch('getSchedulerListByDateAction', {Date:datetime}).then((res) => {
        if(res.data.data.length === 0) return;
        var joinStartTime = res.data.data[0].StartTime 
        var startTimeHours = moment.utc(joinStartTime).format('HH');
        var startTimeMins = moment.utc(joinStartTime).format('mm:ss');
        var currentLocalHours = moment().format('HH');
        var currentLocalMins = moment().format('mm:ss');
        var totalMinutesOfStartMeeting  = startTimeHours*parseInt(60) + parseInt(startTimeMins);
        var totalMinutesOfCurrent  = currentLocalHours*parseInt(60) + parseInt(currentLocalMins);
        if(totalMinutesOfStartMeeting > totalMinutesOfCurrent){
          var validTime = totalMinutesOfStartMeeting - totalMinutesOfCurrent
          if(parseInt(30) > validTime){
            // if(Push.Permission.has()){
            //   Push.create(res.data.data[0].Subject, {
            //     body:'Check Your Lymphomap To Scheduler',
            //     timeout:5000,
            //     onClick: function () {
            //         window.focus();
            //         this.close();
            //         console.log(res.data.data[0].Id)
            //         __self.schedulerIsReadStatusUpdateMethod(res.data.data[0].Id);
            //     }
            //   })
            // }
          }
        }
      })
    },
    getBrowserVersion() {
        var ua= navigator.userAgent, tem,
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M[1];
    },
    closeModal() {
      sessionStorage.setItem("isClosed", true);
      this.isClosed = true;
    },
    /*
    * this will check if user has getUserMedia
    */
    hasUserMedia() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      return !!navigator.getUserMedia;
    },
    /*
    * this will check that user browser supports webrtc or not
    */
    hasRTCPeerConnection() {
      window.RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
      window.RTCSessionDescription = window.RTCSessionDescription || window.webkitRTCSessionDescription || window.mozRTCSessionDescription;
      window.RTCIceCandidate = window.RTCIceCandidate || window.webkitRTCIceCandidate || window.mozRTCIceCandidate;
      return !!window.RTCPeerConnection;
    },
    playSound (sound) {
      if(sound) {
        this.audioPlayer = new Audio(sound);
        this.audioPlayer.play();
      }
    },
    stopSound () {
      if(this.audioPlayer == null) return; 
      this.audioPlayer.muted = true;
      this.audioPlayer.pause();
      this.audioPlayer.currentTime = 0;
      this.audioPlayer = null
    },
    commonSocketConnectMethod(){
      let callerID = '3548d149becb44e9';
      commonSocket.connect(callerID);
      commonSocket.$on('connection', response => {
        const payload = {
          type: "userLogin",
          userID: this.currentUserId,
          message: "User Login",
          second_user_id:''
        };
        commonSocket.emit(payload);
      });
      commonSocket.$on('userLogin', this.handleUserLogin);
      commonSocket.$on('userLogout', this.handleSelfUserLogoutStatus);
      commonSocket.$on('userLogin', this.handleSelfUserStatus);
      commonSocket.$on('selfUserStatus', this.handleAllUserStatus);
      commonSocket.$on('userLogout', this.handleUserLogout);
    },
    videoNotficationAlertPopupForSocket(){
      this.$store.dispatch('roomCreateIdforGlobalSocketMethod').then((res) => {
        let callerID = res.data.data.val;
        videoSocketRef.connect(callerID);
        videoSocketRef.$on('videoCallingNotification', this.getVideoNotificationMsg);
        videoSocketRef.$on('videoCallAlertPopupClosed', this.callerPopupClosedInOtherTabs);
        videoSocketRef.$on('friendRequest', this.handleFriendRequest);
        videoSocketRef.$on('newMessageNotification', this.handleNewMessageNotification);
        videoSocketRef.$on('newChatMessageOfGroupRoomNotification', this.handleNewMessageOfGroupRoomNotification);
        videoSocketRef.$on('TypingEventForSelectedUserNotification', this.handleTypingEventForSelectedUserNotification);
        videoSocketRef.$on('TypingEventForSelectedGroupNotification', this.handleTypingEventForSelectedGroupNotification);
        videoSocketRef.$on('messageDeleteForChatOfAllNotification', this.handleMessageDeleteForChatOfAllNotification);
        videoSocketRef.$on('messageForwardedOfUsersNotification', this.handleMessageForwardedOfUsersNotification);
      })
    },
    handleMessageForwardedOfUsersNotification(response) {
      const toUserID = response.toUserID;
      if(toUserID == this.currentUserId) return;
      try {
        const payload = {
          chat_data: response.chat_data,
          toUserID: response.toUserID,
          targetUsersID:response.targetUsersID,
          colour:response.colour,
          message_id_arr:response.message_id_arr,
        };
        bus.$emit('forwardedMessageNotifications', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleNewMessageNotification(response) {
      const toUserID = response.toUserID;
      const fromUserID = response.fromUserID;
      if(fromUserID == this.currentUserId || toUserID != this.currentUserId) return;
      try {
        const payload = {
          chatRoomId: response.chatRoomId,
          toUserID: response.toUserID,
          fromUserID: response.fromUserID,
          unreadCount: response.unreadCount,
          totalUnreadCount: response.totalUnreadCount,
          senderMsgData:response.senderMsgData,
          msgSenderFullName:response.msgSenderFullName
        };
        bus.$emit('updateMessageNotification', payload);
        bus.$emit('updateMessageNotifications', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleNewMessageOfGroupRoomNotification(response) {
      const toUserID = response.selfUserID;
      if(toUserID == this.currentUserId) return;
      for(var i = 0; i < response.ingroupusers.length; i++){
        if(response.ingroupusers[i] == this.currentUserId){
          try {
            const payload = {
              selfUserID: response.selfUserID,
              chatRoomId: response.chatRoomId,
              unreadCount: response.unreadCount,
              totalUnreadCount: response.totalUnreadCount,
              senderMsgData:response.senderMsgData,
              msgSenderFullName:response.msgSenderFullName
            };
            bus.$emit('updateMessageNotificationOfGroupRoom', payload);
            bus.$emit('updateMessageNotifications', payload);
          } catch(e) {
            console.log(e);
          }
        }
      }
    },
    getVideoNotificationMsg(getData){
      if(this.soketForSelfUserId == getData.targetId){
        if(Push.Permission.has()){
          Push.create('Lymphomap Video Call From ' + getData.displayName, {
            body:'Check Your lymphomap to answer',
            timeout:5000,
            onClick: function () {
                window.focus();
                this.close();
            }
          })
        }
        $('body').addClass('videoNotificationPopup')
        this.callerName = getData.displayName
        this.videoCallerUserId = getData.callerID
        this.incomingCallNotification = true
        // this.playSound(audioPlay)
      }
    },
    callerPopupClosedInOtherTabs(closeOtherTabData){
      if(this.soketForSelfUserId != closeOtherTabData.videoCallRoomId) return;
      if(closeOtherTabData.type == 'videoAlertPopupClose'){
        this.stopSound()
        $('body').removeClass('videoNotificationPopup')
        this.callerName = ''
        this.incomingCallNotification = false
      }
    },
    closeSocket() {
      if(commonSocket.isOpen()) {
        commonSocket.close();
      }
    },
    handleFriendRequest(response) {
      const userID = response.userID;
      const fromUserID = response.fromUserID;
      if(fromUserID == this.currentUserId || userID != this.currentUserId) return;
      try {
        const payload = {
          userID
        };
        bus.$emit('userFriendRequest', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleUserLogout(response) {
      const userID = response.userID;

      if(userID == this.currentUserId) return;

      try {
        const payload = {
          userID: response.userID,
          is_online: false,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleSelfUserLogoutStatus(response) {
      const userID = response.userID;
      if(userID != this.currentUserId) return;
      try {
        const payload = {
          userID: response.userID,
          is_online: false,
        };
        bus.$emit('selfUserUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleUserLogin(response) {
      const userID = response.userID;

      if(userID == this.currentUserId) return;

      try {
        const payload = {
          userID: response.userID,
          is_online: true,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleSelfUserStatus(response) {
      const userID = response.userID;
      if(userID != this.currentUserId) return;
      try {
        const payload = {
          userID: response.userID,
          is_online: true,
        };
        bus.$emit('selfUserUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleTypingEventForSelectedUserNotification(response){
      const suserID = response.selfUserID;
      if(suserID == this.currentUserId) return;
      const userID = response.targetForChatUserId;
      if(userID == this.currentUserId){
        bus.$emit('TypingEventForSelectedUserBus', response);
      }
    },
    handleTypingEventForSelectedGroupNotification(response){
      const toUserID = response.selfUserID;
      if(toUserID == this.currentUserId) return;
      if(response.message == 'typing'){
        if(!response.ingroupuser) return;
        for(var i = 0; i < response.ingroupuser.length; i++){
          if(response.ingroupuser[i].user.id == this.currentUserId){
            bus.$emit('TypingEventForSelectedGroupBus', response);;
          }
          if(response.ingroupuser[i].user.id == toUserID){
            bus.$emit('getUserInfoTypingEventForSelectedGroupBus', response.ingroupuser[i].user);
          }
        }
      }else{
        bus.$emit('TypingEventForSelectedGroupBus', response);
      }
    },
    handleMessageDeleteForChatOfAllNotification(response){
      const toUserID = response.selfUserID;
      if(toUserID == this.currentUserId) return;
      bus.$emit('MessageDeleteForChatOfAllNotification', response);
    },
    handleAllUserStatus(response) {
      const userID = response.userID;
      if(userID == this.currentUserId) return;
      try {
        const payload = {
          userID: response.userID,
          current_status:response.current_status,
          status_time:response.status_time
        };
        bus.$emit('userSelfStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
  },
  watch:{
    getUserDetailsAgainFun(){
      return this.$store.getters.selfUserInfoGetters.data
    },
    setIntialStates(){
      if(this.userDetails){
        this.soketForSelfUserId = this.userDetails.id
      }
      return
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.closeSocket)
  },
  beforeDestroy() {
    if(commonSocket.isOpen()) {
      commonSocket.close();
    }
    window.removeEventListener("beforeunload", this.closeSocket);
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
    $('body').addClass('sidebar_collapsed')
    $('body').removeClass('videoNotificationPopup')
  },
  beforeRouteLeave: function(to, from, next) {
    this.stopSound()
    $('body').removeClass('dashboard')
    $('body').removeClass('videoNotificationPopup')
    clearInterval(schedulerPushNotification)
    next();
  },
}
</script>
<style lang="scss" scoped>
.dashboard_wrp {
    min-height: 100dvh;
    padding: 70px 10px 10px;
    position: relative;
    transition:all ease 0.5s;
    -webkit-transition:all ease 0.5s;
    -moz-transition:all ease 0.5s;
    @media only screen and (max-width:767px){
      padding: 70px 0 10px;
    }
}
.dashboard_wrp .lymphomap_main {
    background: rgba(0, 0, 0, 0.6);
    border-radius: 3px;
    padding: 15px;
    min-height: calc(100dvh - 80px);
    position: relative;
    width: 100%;
    margin-left: auto;
}
.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background-color: #000;
    opacity: .5;
}
.unsupported-browser {
  &.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    overflow: hidden;
    outline: 0;
    &.modal-open {
      overflow-x: hidden;
      overflow-y: auto;
      display: block;
    }
    .modal-dialog {
      position: relative;
      width: auto;
      margin: .5rem;
      pointer-events: none;
      @media (min-width: 576px) {
        max-width: 500px;
        margin: 1.75rem auto;
      }
      &.modal-dialog-centered {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        min-height: calc(100% - (.5rem * 2));
        @media (min-width: 576px) {
          min-height: calc(100% - (1.75rem * 2));
        }
      }
      .modal-content {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        width: 100%;
        pointer-events: auto;
        background-color: #000000;
        background-clip: padding-box;
        border: 1px solid rgba(255,255,255,.2);
        border-radius: .3rem;
        outline: 0;
        box-shadow: -1px -1px 18px rgba(251,247,165,0.3);
        .modal-body {
          padding: 30px;
          @media (max-width: 575px){
            padding: 15px;
          }
          h3 {
            color: #fbf7a5;
            font-weight: 600;
            letter-spacing: 1px;
            @media (max-width: 575px){
              font-size: 24px;
            }
          }
          p {
            letter-spacing: 1.3px;
            color: #ffffff;
            font-weight: 400;
            font-size: 14px;
            font-family: 'MyriadProRegular','Lato',sans-serif;
            line-height: 1.7;
            @media (max-width: 575px){
              font-size: 13px;
            }
          }
          .btn {
            background: #ffc800 !important;
            border: none !important;
            color: #000 !important;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            font-size: 14px;
            font-weight: 600;
            font-family: 'MyriadProRegular','Lato',sans-serif;
            letter-spacing: 1px;
            &:hover {
              background: #87cefa !important;
              color: #22292f !important;
            }
          }
        }
      }
    }
  }
  .browser-list {
    padding: 0;
    margin: 0 0 20px;
    list-style: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    li {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 33.33333%;
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
      text-align: center;
      padding: 0px 4px;
      a {
        color: #ffd700;
        letter-spacing: 1.3px;
        font-size: 13px;
        @media (max-width: 575px){
          font-size: 9px;
        }
      }
      span {
        display: block;
        margin-top: 3px;
        font-size: 13px;
        color: #f2f2f2;
        font-family: 'MyriadProRegular','Lato',sans-serif;
        letter-spacing: 1px;
        @media (max-width: 575px){
          font-size: 11px;
        }
      }
      img {
        max-width: 60px;
        display: block;
        margin: 0 auto 15px;
        @media (max-width: 575px){
          max-width: 40px;
        }
      }
    }
  }
}
</style>